module.exports = __webpack_public_path__ + "static/media/7.1.83d91748.png";